import { useAuth } from "@/context/AuthContext";
import AppHeader from "@/components/AppHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CredentialWallet from "@/components/CredentialWallet";
import BrowseShifts from "@/components/BrowseShifts";
import MyApplications from "@/components/MyApplications";
import Earnings from "@/components/Earnings";
import PeerCovers from "@/components/PeerCovers";

export default function ProfessionalPage() {
  const { user, refresh } = useAuth();
  const verified = user?.credential_status === "verified";

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <AppHeader subtitle="Professional workspace" />
      <div className="max-w-4xl mx-auto px-4 md:px-5 py-6 md:py-10">
        <Tabs defaultValue={verified ? "browse" : "wallet"}>
          <TabsList className="rounded-full h-11 p-1 bg-slate-100 flex flex-wrap sm:inline-flex">
            <TabsTrigger value="wallet" data-testid="tab-wallet" className="rounded-full">Wallet</TabsTrigger>
            <TabsTrigger value="browse" data-testid="tab-browse" className="rounded-full">Browse shifts</TabsTrigger>
            <TabsTrigger value="applications" data-testid="tab-applications" className="rounded-full">My applications</TabsTrigger>
            <TabsTrigger value="covers" data-testid="tab-covers" className="rounded-full">Peer covers</TabsTrigger>
            <TabsTrigger value="earnings" data-testid="tab-earnings" className="rounded-full">Earnings</TabsTrigger>
          </TabsList>

          <TabsContent value="wallet" className="mt-6"><CredentialWallet user={user} onChanged={refresh} /></TabsContent>
          <TabsContent value="browse" className="mt-6"><BrowseShifts verified={verified} /></TabsContent>
          <TabsContent value="applications" className="mt-6"><MyApplications /></TabsContent>
          <TabsContent value="covers" className="mt-6"><PeerCovers verified={verified} /></TabsContent>
          <TabsContent value="earnings" className="mt-6"><Earnings /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
